export default __webpack_public_path__ + "static/media/hero-img-new@2x.0dcdd898.png";